import http from "../../helpers/http";
import httpos from "../../helpers/httpos";
import * as helpers from "../../helpers/helpers";
import { toast } from "react-toastify";
import { TOAST_SETTINGS } from "../../utils/siteSettings";
import Text from "../../components/common/Text";

import {
    FETCH_EXPORT_CONTENT,
    FETCH_EXPORT_CONTENT_SUCCESS,
    FETCH_EXPORT_CONTENT_FAILED,
    EXPORT_MESSAGE,
    EXPORT_MESSAGE_SUCCESS,
    EXPORT_MESSAGE_FAILED,
} from "./actionTypes";

export const getExportProperties = (formData) => (dispatch) => {
    dispatch({
        type: FETCH_EXPORT_CONTENT,
        payload: null
    });
    httpos
        .post(
            "export-properties", helpers.doObjToFormData(formData))
        .then(({ data }) => {
            dispatch({
                type: FETCH_EXPORT_CONTENT_SUCCESS,
                payload: data
            });
        })
        .catch((error) => {
            console.log(error)
            dispatch({
                type: FETCH_EXPORT_CONTENT_FAILED,
                payload: error
            });
        });
};

export const postExportPdf = (formData) => (dispatch) => {
    dispatch({
        type: EXPORT_MESSAGE,
        payload: null
    });
    http
        .post("export-properties-csv", helpers.doObjToFormData(formData))
        .then(({ data }) => {
            if (data.status) {
                toast.success(
                    `${data.msg}`,
                    TOAST_SETTINGS
                );
                dispatch({
                    type: EXPORT_MESSAGE_SUCCESS,
                    payload: data
                });
            } else {
                toast.error(
                    <Text string={data.msg} parse={true} />,
                    TOAST_SETTINGS
                );
                dispatch({
                    type: EXPORT_MESSAGE_FAILED,
                    payload: null
                });
            }
        })
        .catch((error) => {
            dispatch({
                type: EXPORT_MESSAGE_FAILED,
                payload: error
            });
        });
};